import { render, staticRenderFns } from "./GetTemplateItem.vue?vue&type=template&id=e8c18bf0&scoped=true&"
import script from "./GetTemplateItem.vue?vue&type=script&lang=js&"
export * from "./GetTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "./GetTemplateItem.vue?vue&type=style&index=0&id=e8c18bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c18bf0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDataTable,VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8c18bf0')) {
      api.createRecord('e8c18bf0', component.options)
    } else {
      api.reload('e8c18bf0', component.options)
    }
    module.hot.accept("./GetTemplateItem.vue?vue&type=template&id=e8c18bf0&scoped=true&", function () {
      api.rerender('e8c18bf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lcd/views/Template/modal/GetTemplateItem.vue"
export default component.exports